import type { SVGProps } from 'react'

/**
 * Shared props for every icon. Icons are decorative by default: pass
 * `aria-hidden` (the callers all do) and give the *button* the accessible
 * name, including the entity it acts on — "Remove Priya Sharma", never
 * "Remove". DESIGN.md §8.5.
 */
export type IconProps = SVGProps<SVGSVGElement>

/** 24x24, currentColor, 1.75 stroke, no fill. No icon font, no sprite, no CDN. */
export const iconDefaults = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const
